var map = {
	"./1-1.png": "b532",
	"./bg-corkboard.jpg": "af3a",
	"./bg-desk.jpg": "dfac",
	"./bg-dialog.png": "ec04",
	"./bg-film-grain.png": "f4e6",
	"./bg-gods.png": "d0da",
	"./bg-intro.png": "bb6c",
	"./bg-journal.png": "b5e5",
	"./bg-map-terrain.png": "b492",
	"./bg-map.png": "7049",
	"./bg-rock.png": "4e5f",
	"./bg-sand.png": "83f1",
	"./bg-scroll-front.png": "31b4",
	"./bg-scroll.png": "54cd",
	"./bg-sunset.png": "7db9",
	"./bg-tape-large.png": "fc8b",
	"./bg-tape-small-1.png": "b95d",
	"./bg-tape-small-2.png": "110c",
	"./bg-thoth-highlight.png": "7828",
	"./bg-thoth.png": "67de",
	"./bg-wall.png": "826e",
	"./bg.jpg": "3625",
	"./cartouche/1.png": "5e9e",
	"./cartouche/2.png": "efbc",
	"./cartouche/3.png": "de80",
	"./cartouche/4.png": "d49a",
	"./cartouche/5.png": "ed69",
	"./cartouche/6.png": "1dbf",
	"./cartouche/7.png": "e797",
	"./desk.png": "c3e9",
	"./egypt-1-1.png": "9bb4",
	"./egypt-1-2.png": "3163",
	"./egypt-1-3.png": "622b",
	"./egypt-1-4.png": "2bfe",
	"./egypt-2-0.png": "cbee",
	"./glass.png": "d8e5",
	"./god-hathor-s.png": "6108",
	"./god-hathor.png": "0f1f",
	"./god-horus-s.png": "c747",
	"./god-horus.png": "7947",
	"./god-mut-s.png": "ba43",
	"./god-mut.png": "52b2",
	"./god-osiris-s.png": "952f",
	"./god-osiris.png": "a59c",
	"./god-thoth-s.png": "ef85",
	"./god-thoth.png": "48d1",
	"./hiero-1.png": "c979",
	"./hiero-2.png": "3cd9",
	"./hiero.png": "2cf7",
	"./hieroglyphs copy/1.png": "762f",
	"./hieroglyphs copy/10.png": "2f1c",
	"./hieroglyphs copy/11.png": "756a",
	"./hieroglyphs copy/12.png": "a61c",
	"./hieroglyphs copy/13.png": "91bc",
	"./hieroglyphs copy/14.png": "f432",
	"./hieroglyphs copy/15.png": "f8e5",
	"./hieroglyphs copy/16-old.png": "9947",
	"./hieroglyphs copy/16.png": "5bec",
	"./hieroglyphs copy/17-new.png": "af2e",
	"./hieroglyphs copy/17.png": "1743",
	"./hieroglyphs copy/18.png": "8325",
	"./hieroglyphs copy/19-old.png": "da9e",
	"./hieroglyphs copy/19.png": "335f",
	"./hieroglyphs copy/2-new.png": "f016",
	"./hieroglyphs copy/2.png": "5313",
	"./hieroglyphs copy/20.png": "28aa",
	"./hieroglyphs copy/21.png": "a498",
	"./hieroglyphs copy/22.png": "6b08",
	"./hieroglyphs copy/23.png": "015f",
	"./hieroglyphs copy/24.png": "6407",
	"./hieroglyphs copy/25.png": "3e59",
	"./hieroglyphs copy/26.png": "3825",
	"./hieroglyphs copy/3.png": "9f80",
	"./hieroglyphs copy/35.png": "ed4e",
	"./hieroglyphs copy/4.png": "6e6c",
	"./hieroglyphs copy/5.png": "583f",
	"./hieroglyphs copy/6.png": "283e",
	"./hieroglyphs copy/7.png": "1aa3",
	"./hieroglyphs copy/8.png": "5807",
	"./hieroglyphs copy/9-1.png": "a6f1",
	"./hieroglyphs copy/9.png": "1c0ba",
	"./hieroglyphs copy/a-1.png": "8edd",
	"./hieroglyphs copy/a-2.png": "277d1",
	"./hieroglyphs copy/a-3.png": "d090",
	"./hieroglyphs copy/a-4.png": "4b5e",
	"./hieroglyphs copy/a-5.png": "3d79",
	"./hieroglyphs/1.png": "2a6f",
	"./hieroglyphs/10.png": "8c29",
	"./hieroglyphs/11.png": "c20f",
	"./hieroglyphs/12.png": "6a4d",
	"./hieroglyphs/13.png": "d035",
	"./hieroglyphs/14.png": "e776",
	"./hieroglyphs/15.png": "89fa",
	"./hieroglyphs/16.png": "2cf0",
	"./hieroglyphs/17-new.png": "2145",
	"./hieroglyphs/17.png": "3d77",
	"./hieroglyphs/18.png": "7f9f",
	"./hieroglyphs/19.png": "1104",
	"./hieroglyphs/2-new.png": "3b8d",
	"./hieroglyphs/2.png": "d59b",
	"./hieroglyphs/20.png": "fc9b",
	"./hieroglyphs/21.png": "58c7",
	"./hieroglyphs/22.png": "51e7",
	"./hieroglyphs/23.png": "adc7",
	"./hieroglyphs/24.png": "9089",
	"./hieroglyphs/25.png": "5b12",
	"./hieroglyphs/26.png": "d66a",
	"./hieroglyphs/3.png": "853f",
	"./hieroglyphs/35.png": "d074",
	"./hieroglyphs/4.png": "c2e0",
	"./hieroglyphs/5.png": "eb61",
	"./hieroglyphs/6.png": "e169",
	"./hieroglyphs/7.png": "9880",
	"./hieroglyphs/8.png": "32d0",
	"./hieroglyphs/9-1.png": "0cbe",
	"./hieroglyphs/9.png": "2d0d",
	"./hieroglyphs/a-1.png": "2398",
	"./hieroglyphs/a-2.png": "f5b9",
	"./hieroglyphs/a-3.png": "ac0d",
	"./hieroglyphs/a-4.png": "ad81",
	"./hieroglyphs/a-5.png": "e140",
	"./hourglass.png": "da2d",
	"./intro-nebet.png": "8331",
	"./journal-c.png": "48ba",
	"./journal-h.png": "2206",
	"./journal-i.png": "cc25",
	"./journal-r.png": "1295",
	"./journal-s.png": "398b",
	"./journal-t.png": "2714",
	"./journal.png": "998a",
	"./lamp.png": "3268",
	"./ling-1-1-fr.png": "cd95",
	"./ling-1-1.png": "6095",
	"./ling-1-2-new.png": "5b72c",
	"./ling-1-2.png": "1774",
	"./ling-1-3.png": "7ecd",
	"./map-large-1.jpg": "d163",
	"./map-large-2.jpg": "4efc",
	"./map-large-3.jpg": "601a",
	"./map-large-4.jpg": "cc86",
	"./map-large-5.jpg": "3fce",
	"./map-location-small-en.jpg": "662e",
	"./map-location-small-en.png": "6f4b",
	"./map-location-small-fr.jpg": "bb21",
	"./map-location-small-fr.png": "d51f",
	"./map-location-xl-en.jpg": "dcf5",
	"./map-location-xl-fr.jpg": "13fe",
	"./map-small-1.png": "a1ee",
	"./map-small-2.png": "ceab",
	"./map-small-3.png": "4dbe",
	"./map-small-4.png": "b162",
	"./map-small-5.png": "be19",
	"./map.png": "8708",
	"./nebet-default-large.png": "135c",
	"./nebet-default-small-invert.png": "81fe",
	"./nebet-default-small.png": "6134",
	"./nebet-final-large.png": "e2e6",
	"./nebet-good-large.png": "d7f4",
	"./nebet-happy-small.png": "68fd",
	"./nebet-question-small.png": "7e0b",
	"./nebet-ruler-large.png": "df5e",
	"./nebet-shock-large.png": "e704",
	"./nebet-show-large.png": "780c",
	"./nebet-show-small.png": "4089",
	"./nebet-unsure-large.png": "4510",
	"./nebet-unsure-small.png": "438a",
	"./nebet-wrong-large.png": "6863",
	"./pedia-large-fr.png": "4ad8",
	"./pedia-large.png": "b601",
	"./pedia-small-fr.png": "84c5",
	"./pedia-small.png": "476b",
	"./pedia-xl-en.png": "4a7e",
	"./pedia-xl-fr.png": "ff45",
	"./pencil.png": "c2d1",
	"./reward-an.png": "e87f",
	"./reward-bg.png": "439c",
	"./reward-sa.png": "7314",
	"./reward-wa.png": "e460",
	"./sand.jpg": "9dd2",
	"./secret-1-1-new.png": "ca02",
	"./secret-1-1.png": "7032",
	"./symbol-cow.png": "94dd",
	"./symbol-djed.png": "2821",
	"./symbol-double-crown.png": "cf1d",
	"./symbol-falcon.png": "7fe4",
	"./symbol-flail.png": "4210",
	"./symbol-hathor-crown.png": "b647",
	"./symbol-ibis.png": "8f1c",
	"./symbol-knot.png": "c1ec",
	"./symbol-palette.png": "769c",
	"./symbol-vulture.png": "5c97",
	"./symbol-wadjet.png": "b86d",
	"./tape-1.png": "ce99",
	"./tape-2.png": "4c25",
	"./tape.png": "1ad6",
	"./tile-1.png": "5e44",
	"./timeline-small-fr.png": "bf5f",
	"./timeline-small.png": "6403",
	"./timeline-xl-en.jpg": "871c",
	"./timeline-xl-fr.jpg": "dfd5",
	"./tomb-1-0.png": "746b",
	"./tomb-1-1.png": "a655",
	"./tomb-2-1.png": "a387",
	"./tomb-2-2.png": "ac3a",
	"./tomb-2-3.png": "c9cf",
	"./tomb-2-4.png": "9276",
	"./tomb-3-0.png": "d0d3",
	"./tomb-3-1.png": "0a86",
	"./tomb-3-2.png": "1c56",
	"./torch.png": "b3cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";